import { create } from 'zustand';
import { AdditionalFields } from '@ohpen/enso-ui';
import { ActionEntityType, getAllAdditionalFields } from '@pmp/api';

type AdditionalFieldsStore = {
  isLoadingAdditionalFields: boolean;
  getAdditionalFields: (entityType: ActionEntityType) => Promise<AdditionalFields>;
};

export const useAdditionalFieldsStore = create<AdditionalFieldsStore>((set, get) => {
  const additionalFields: Partial<Record<ActionEntityType, AdditionalFields>> = {};

  return {
    isLoadingAdditionalFields: false,

    getAdditionalFields: async (entityType: ActionEntityType) => {
      const { isLoadingAdditionalFields } = get();

      if (isLoadingAdditionalFields) {
        return new Promise<AdditionalFields>(resolve => {
          const interval = setInterval(() => {
            const additionalFieldsForEntity = additionalFields[entityType];
            if (additionalFieldsForEntity) {
              clearInterval(interval);
              resolve(additionalFieldsForEntity);
            }
          }, 100);
        });
      }

      if (!additionalFields[entityType]) {
        set({ isLoadingAdditionalFields: true });

        try {
          // TODO : Remove this condition when the API is ready
          const { data } = entityType === ActionEntityType.PRODUCTS ? await getAllAdditionalFields() : { data: {} };
          additionalFields[entityType] = data || {};
          set({ isLoadingAdditionalFields: false });
          return additionalFields[entityType];
        } catch (error) {
          console.error('Failed to load additional fields:', error);
          set({ isLoadingAdditionalFields: false });
          throw error;
        }
      }

      return additionalFields[entityType];
    },
  };
});
